export default {
  sm: `
  일상 속의
  데이터 
  `
};
